const ACCESS_TOKEN_KEY = 'token';
const REFRESH_TOKEN_KEY = 'refresh_token';
const POLICIES_KEY = 'user_policies';

export function getAccessToken(): string | null {
  return localStorage.getItem(ACCESS_TOKEN_KEY);
}

export function getRefreshToken(): string | null {
  return localStorage.getItem(REFRESH_TOKEN_KEY);
}

export function getStoredPolicies(): unknown[] | null {
  const raw = localStorage.getItem(POLICIES_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

export function setTokens(
  tokens: {
    access_token: string;
    refresh_token: string;
  },
  policies?: unknown[],
): void {
  localStorage.setItem(ACCESS_TOKEN_KEY, tokens.access_token);
  localStorage.setItem(REFRESH_TOKEN_KEY, tokens.refresh_token);
  if (policies && Array.isArray(policies)) {
    localStorage.setItem(POLICIES_KEY, JSON.stringify(policies));
  }
}

export function clearTokens(): void {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  localStorage.removeItem(POLICIES_KEY);
}

export function isAuthenticated(): boolean {
  return Boolean(getAccessToken());
}

